import React from 'react'
import Avatar from 'components/Avatar'
import styled from 'styled-components'
import Flex from 'components/Flex'
import ApartmentIcon from 'components/icons/ApartmentIcon'
import { COLORS } from 'theme'
import { FONT } from 'theme/font'
const HeaderFlex = styled(Flex)`
  gap: 10px;
`

const InstituteName = styled.h2`
  font-style: normal;
  font-weight: ${FONT.FW_600};
  font-size: ${FONT.F_SM};
  line-height: 20px;
  color: ${COLORS.BLACK_WHITE_B_100};
  margin-bottom: 0;
`
const Location = styled.p`
  font-style: normal;
  font-weight: ${FONT.FW_500};
  font-size: ${FONT.F_XS};
  line-height: 20px;
  color: ${COLORS.BLACK_WHITE_B_100};
  opacity: 0.48;
  margin-bottom: 0;
  text-transform: capitalize;
`

const HeaderInstituteInfo = ({ corporateData }) => {
  return (
    <HeaderFlex>
      <div>
        <Avatar
          background="none"
          src={corporateData?.logo ? corporateData?.logo : ''}
          size={37}
          icon={
            !corporateData?.logo && <ApartmentIcon width="24" height="24" />
          }
          boxShadow={true}
          padding={corporateData?.logo ? '' : '5px'}
        />
      </div>
      <Flex column>
        <InstituteName>{corporateData?.name}</InstituteName>
        <Location>
          {corporateData?.city}, {corporateData?.state}
        </Location>
      </Flex>
    </HeaderFlex>
  )
}

export default HeaderInstituteInfo
